export const AUDIT_EMAIL_WARNING_DURATION_MS = 6000;
export const AUDIT_EMAIL_WARNING_DELAY_MS = 500;
